import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { CircularProgress, Box } from "@mui/material";
import VerifyEmailPage from "app/Pages/VerifyEmailPage";
import { RootState } from "store";

const RootContainer = styled("div")({
  minHeight: "70vh",
  margin: "auto",
});

interface ProtectedRouteProps {
  children: React.ReactNode;
}

function ProtectedRoute({ children }: ProtectedRouteProps): JSX.Element {
  const user = useSelector((state: RootState) => state.user.user);
  const navigate = useNavigate();
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    console.log("ProtectedRoute: User state changed", user ? "User logged in" : "No user");
    if (!user) {
      setIsRedirecting(true);
      navigate("/", { replace: true });
    }
  }, [user, navigate]);

  const renderContent = (): React.ReactNode => {
    if (!user || isRedirecting) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "50vh",
          }}
        >
          <CircularProgress />
        </Box>
      );
    }
    if (user && !user.emailVerified) {
      return <VerifyEmailPage />;
    }
    return children;
  };

  return <RootContainer>{renderContent()}</RootContainer>;
}

export default ProtectedRoute;
